import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxStoreProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import './index.css'
import App from './App'
import env from './env/env'
import { persistor, store } from './store/store'
import { preloadGoogleMaps } from './utils/preloadGoogleMaps'

preloadGoogleMaps()

/**
 * SEO: Prevent search engine indexing on non-production environments
 */
if (env.NODE_ENV !== 'production') {
  const noIndexMeta = document.createElement('meta')
  noIndexMeta.name = 'robots'
  noIndexMeta.content = 'noindex, nofollow'
  document.head.appendChild(noIndexMeta)
}

const root = ReactDOM.createRoot(document.getElementById('root')!)

if (env.NODE_ENV === 'mockserver') {
  // Prepare MSW in a Service Worker
  import('../mocks/browser')
    .then(({ worker }) => {
      worker.start()
    })
    // Launched mock server, and then start client React app
    .then(() =>
      root.render(
        <ReduxStoreProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </ReduxStoreProvider>,
      ),
    )
} else {
  // Production
  root.render(
    <ReduxStoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </ReduxStoreProvider>,
  )
}
